import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.537 3c-.424 0-.789-.277-1.02-.633A2.998 2.998 0 0 0 12 1a2.998 2.998 0 0 0-2.517 1.367c-.231.356-.596.633-1.02.633H4a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4.463ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.955 5.66c.709.444 1.045 1.266 1.045 2.102V20H5v-2.238c0-.836.336-1.658 1.045-2.103C7.71 14.616 9.988 14 12 14s4.29.616 5.955 1.66Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.537 3c-.424 0-.789-.277-1.02-.633A2.998 2.998 0 0 0 12 1a2.998 2.998 0 0 0-2.517 1.367c-.231.356-.596.633-1.02.633H4a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4.463ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.955 5.66c.709.444 1.045 1.266 1.045 2.102V20H5v-2.238c0-.836.336-1.658 1.045-2.103C7.71 14.616 9.988 14 12 14s4.29.616 5.955 1.66Z",
      fill: "currentColor"
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconPlaceholderCardAgent24 = createIcon(IconComponent);